<div class="container p-0">
  <mat-dialog-content>
    <div class="modal-dialog my-0">
      <div class="modal-content">
        <div class="text-center">
          <h4 class="font-semibold ml-auto mr-auto text-2xl">Unsaved Work</h4>
        </div>
        <div class="modal-body">
          <ng-container>
            <h6 class="text-center mt-5 mb-10">
              Warning you have unsaved work please select 
              from the options below:
            </h6>
          </ng-container>
        </div>

        <div class="block text-center">
          <div class="mb-5">
            <a (click)="continueWithoutSave()"> Continue without saving </a>
          </div>
          <div class="mb-5">
            <a (click)="returnToPage()"> Return to page </a>
          </div>
          <div class="mb-5">
            <span class="cursor-not-allowed" #tooltip="matTooltip" matTooltip="Please fill out all required fields."
              [matTooltipPosition]="'below'" matTooltipHideDelay="100000" *ngIf="data.form && !data.form.valid; else validTmpl">
              <a (click)="saveAndContinue()" class="pointer-events-none text-gray-400"> Save work and continue </a>
            </span>
            <ng-template #validTmpl>
              <a (click)="saveAndContinue()"> Save work and continue </a>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>